import React,{useState} from 'react';
import { ButtonToolbar, Button, ModalFooter } from 'react-bootstrap';
import './styles/App.css';
import imgFrameApartWhite from './img/icon/apart_ico_white.png';
import imgFrameGlass from './img/service_off_1.jpg';
import imgFrameGlassWhite from './img/service_on_1.jpg';
import imgFrameBang from './img/service_off_2.jpg';
import imgFrameBangWhite from './img/service_on_2.jpg';
import imgFrameCare from './img/service_off_3.jpg';
import imgFrameCareWhite from './img/service_on_3.jpg';
import imgFrameCareOk from './img/service_off_4.jpg';
import imgFrameCareOKWhite from './img/service_on_4.jpg';
import { Col } from 'react-bootstrap';  



function MidContent({ history }){

    const [isShown4, setIsShown4] = useState(false);
    const [isShown5, setIsShown5] = useState(false);
    const [isShown6, setIsShown6] = useState(false);
    const [isShown7, setIsShown7] = useState(false);
    const hover = {
        cursor:"pointer",
        background:"#fff"
    }

    const cursorPointer = {
        cursor:"pointer"
    }
    const hoverColor1 = {
        borderright:"1px solid lightgray"
    }
    const Midphoto = {
        padding: '20px 0px'
    }
   
    return(
    <>
        <div className="menubox2">
                        <div className="container py-4">
                            <div style={hover}  className="inbox row p-0">
                                <div style={Midphoto} className="col midMenuIn" onMouseEnter={() => setIsShown4(true)} onMouseLeave={() => setIsShown4(false)} style={cursorPointer}   onClick={() => {history.push('/apply')}}>
                                    <div className="hoverColor text-center col-7 mx-auto">
                                        {isShown4
                                        ?<img className="img-fluid" src={imgFrameGlassWhite}/>
                                        :<img className="img-fluid" src={imgFrameGlass}/>
                                        }
                                    </div>
                                    <p className="sub_menu_text text-center mb-0 font-weight-bold">서비스 신청</p>
                                </div>
                                <div className="Thinline"></div>
                                <div className="col midMenuIn" onMouseEnter={() => setIsShown5(true)} onMouseLeave={() => setIsShown5(false)} onClick={() => window.sessionStorage.result ? history.push('/repFindShop') : alert('로그인 이후 가능한 서비스 입니다.')} style={cursorPointer}>
                                    <div className="hoverColor text-center col-7 mx-auto">
                                        {isShown5
                                        ?<img className="img-fluid" src={imgFrameBangWhite}/>
                                        :<img className="img-fluid" src={imgFrameBang}/>
                                        }
                                    </div>
                                    <p className="sub_menu_text text-center font-weight-bold mb-0">빠른예약</p>
                                </div>
                                <div className="Thinline"></div>
                                <div className="col midMenuIn" onMouseEnter={() => setIsShown6(true)} onMouseLeave={() => setIsShown6(false)} onClick={() => window.sessionStorage.result ? history.push('/represent') : alert('로그인 이후 가능한 서비스 입니다.')} style={cursorPointer}>
                                    <div className="hoverColor text-center col-7 mx-auto">
                                        {isShown6
                                        ?<img className="img-fluid" src={imgFrameCareWhite}/>
                                        :<img className="img-fluid" src={imgFrameCare}/>
                                        }
                                    </div>
                                    <p className="sub_menu_text text-center font-weight-bold mb-0">예약확인</p>
                                </div>
                                <div className="Thinline"></div>
                                <div className="col midMenuIn" onMouseEnter={() => setIsShown7(true)} onMouseLeave={() => setIsShown7(false)} onClick={() => window.sessionStorage.result ? history.push('/progress') : alert('로그인 이후 가능한 서비스 입니다.')} style={cursorPointer}>
                                    <div className="hoverColor text-center col-7 mx-auto">
                                        {isShown7
                                        ?<img className="img-fluid" src={imgFrameCareOKWhite}/>
                                        :<img className="img-fluid" src={imgFrameCareOk}/>
                                        }
                                    </div>
                                    <p className="sub_menu_text text-center font-weight-bold mb-0">서비스 확인</p>
                                </div>
                            </div>
                        </div>
        </div>
  
    </>
    )

}


export default MidContent;